import { render, staticRenderFns } from "./resList.vue?vue&type=template&id=739cedb4&"
import script from "./resList.vue?vue&type=script&lang=js&"
export * from "./resList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports